module.exports = __webpack_public_path__ + "static/img/christina-warner-JELUPXqdKDw.1f148c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911261/christina-warner-JELUPXqdKDw.jpg
// module id = wiwR
// module chunks = 1